import React from 'react'

export default function CampaignIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.33333 4C9.36092 4.05223 11.3426 3.39167 12.9333 2.13333C13.0324 2.05905 13.1502 2.01381 13.2735 2.00269C13.3968 1.99158 13.5207 2.01501 13.6315 2.07038C13.7422 2.12575 13.8353 2.21086 13.9004 2.31618C13.9655 2.4215 14 2.54286 14 2.66667V10.6667C14 10.7905 13.9655 10.9118 13.9004 11.0172C13.8353 11.1225 13.7422 11.2076 13.6315 11.263C13.5207 11.3183 13.3968 11.3418 13.2735 11.3306C13.1502 11.3195 13.0324 11.2743 12.9333 11.2C11.3426 9.94166 9.36092 9.2811 7.33333 9.33333H3.33333C2.97971 9.33333 2.64057 9.19286 2.39052 8.94281C2.14048 8.69276 2 8.35362 2 8V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333Z"
        stroke="#9CA3AF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9.33594C4 11.0669 4.56142 12.7512 5.6 14.1359C5.81217 14.4188 6.12804 14.6059 6.4781 14.6559C6.82817 14.7059 7.18377 14.6148 7.46667 14.4026C7.74956 14.1904 7.93659 13.8746 7.9866 13.5245C8.03661 13.1744 7.94551 12.8188 7.73333 12.5359C7.04095 11.6128 6.66667 10.4899 6.66667 9.33594"
        stroke="#9CA3AF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33325 4V9.33333"
        stroke="#9CA3AF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
